import * as React from 'react';
import { initObservability } from '@authe/fe-commons/observability';
export { addBreadcrumb, captureException, captureMessage, initObservability, recordApiResponse } from '@authe/fe-commons/observability';
import { jsx, Fragment } from 'react/jsx-runtime';

// src/observability/ObservabilityProvider.tsx
function configFromEnv(env) {
  if (!env) return {};
  const cfg = {};
  if (env.sentryDsn) {
    cfg.sentry = { dsn: env.sentryDsn, environment: env.env };
  }
  if (env.rumAppId && env.rumIdentityPoolId && env.rumRegion) {
    cfg.rum = {
      applicationId: env.rumAppId,
      identityPoolId: env.rumIdentityPoolId,
      region: env.rumRegion
    };
  }
  return cfg;
}
function ObservabilityProvider({
  env,
  config,
  forwardLogs = true,
  children
}) {
  const didInit = React.useRef(false);
  const propsRef = React.useRef({ env, config, forwardLogs });
  propsRef.current = { env, config, forwardLogs };
  React.useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;
    const { env: e, config: c, forwardLogs: fwd } = propsRef.current;
    const merged = { ...configFromEnv(e), ...c };
    if (!merged.sentry && !merged.rum) return;
    merged.forwardLogs = merged.forwardLogs ?? fwd;
    void initObservability(merged);
  }, []);
  return /* @__PURE__ */ jsx(Fragment, { children });
}

export { ObservabilityProvider };
//# sourceMappingURL=chunk-WOQRPD42.js.map
//# sourceMappingURL=chunk-WOQRPD42.js.map